var FiltriContenuto = (function () {


  /* ---------------------------------------------------------
  APERTURA SUPERTILE - da click su tile temi, menu progetti
  --------------------------------------------------------- */

  var toggleSuperTile = function () {

    function openFilters(){
      // #menu-filters non più gestito dal menu navbar — rimane d-none
    }

    // filters panel toggle — disabilitato (non gestito dal menu)
    // Il pannello #menu-filters resta nascosto (d-none nel markup)

    // FILTRO TIPI DI CONTENUTO:
    // PROGETTI / EVENTI / CONTRIBUTI
    $('#subfilters-menu-items li a').on('click',function(e){
    	var this_index = $(this).parent('li').index();
    	$('#subfiltri-globali nav').addClass('hidden');
    	$('#subfiltri-globali nav').eq(this_index).removeClass('hidden');
    });

    // LIMITATORE HEIGHT FILTRI
    $('#subfiltri-globali > nav > ul').each(function(){
      $height = $(this).actual('height');

      if($height > 24){
        $(this).prev('span.titolo-filtro').append('<i class="ms-3 fal fa-arrow-right"></i>').attr('isopen', 'off').css('cursor', 'pointer');
        $(this).css('max-height', 22);
      }
    });

    $('span.titolo-filtro').click(function(e){
      e.stopImmediatePropagation();

      if( $(this).attr('isopen') !== 'on' ){
        $(this).attr('isopen', 'on');
        $(this).next('ul').css('max-height', 'none');
      } else {
        $(this).attr('isopen', 'off');
        $(this).next('ul').css('max-height', 22);
      }
    });

    /* ^ FINE toggleSuperTile() ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  CONTROLLER CAMBIO EDIZIONE
  --------------------------------------------------------- */

  var cambioEdizione = function (){

    // filtro edizioni
    $('#edizioni-select').on('click', 'li', function(e){
      $('#edizioni-select li').removeClass('selected');
      $(this).toggleClass('selected');

      edition = $('ul#edizioni-select li.selected').val(); //es. 2019
      UbpHome.datiEdizione(edition);

      $('#filtri-globali').append('<div id="edition-loader"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></di');
    });

    /* ^ FINE cambioEdizione() ----------------------------------------- */
  };




  /* ---------------------------------------------------------
  UPDATE DEI FILTRI NELLA SUPERTILE
  usato da: UbpHome.datiEdizione
  --------------------------------------------------------- */

  var update_filtri = function (filter_data){

    // aggiorna select temi
  	var temi_items = '';
  	for (var i=0;i<filter_data.temi.length;i++){
  		if (filter_data.temi[i].slug !== '') {
  			temi_items += '<li class="pr-2 me-2" data-title="'+filter_data.temi[i].name+'" data-filter=".temi-'+filter_data.temi[i].slug+'">'+filter_data.temi[i].name+'</li>';
  		}
  	}
  	$('#filters-temi li:not(:last)').remove();
  	$('#filters-temi').prepend(temi_items);
    // se non ci sono termini non mostro il filtro
    if(filter_data.temi.length > 0){
      $('#filtri-temi').removeClass('d-none');
    } else {
      $('#filtri-temi').addClass('d-none');
    }


    // aggiorna select parolechiave
    var parolechiave_items = '';
    for (var i=0;i<filter_data.parolechiave.length;i++){
      if (filter_data.parolechiave[i].slug !== '') {
        parolechiave_items += '<li class="pr-2 me-2" data-title="'+filter_data.parolechiave[i].name+'" data-filter=".parolechiave-'+filter_data.parolechiave[i].slug+'">'+filter_data.parolechiave[i].name+'</li>';
      }
    }
    $('#filters-parolechiave li:not(:last)').remove();
    $('#filters-parolechiave').prepend(parolechiave_items);
    // se non ci sono termini non mostro il filtro
    if(filter_data.parolechiave.length > 0){
      $('#filtri-parolechiave').removeClass('d-none');
    } else {
      $('#filtri-parolechiave').addClass('d-none');
    }


    // aggiorna select promotori
  	var promotori_options = '';
  	for (var i=0;i<filter_data.promotori.length;i++){
  		if (filter_data.promotori[i].slug !== '') {
  			promotori_options += '<li class="pr-2 me-2" value=".promotore-'+filter_data.promotori[i].slug+'">'+filter_data.promotori[i].name+'</li>';
  		}
  	}
  	$('#promotori-select li:not(:last)').remove();
    $('#promotori-select').prepend(promotori_options);
    // se non ci sono termini non mostro il filtro
    if(filter_data.promotori.length > 0){
      $('#filtri-promotori').removeClass('d-none');
    } else {
      $('#filtri-promotori').addClass('d-none');
    }


    // aggiorna select luoghi
  	var luoghi_options = '';
  	for (var i=0;i<filter_data.luoghi.length;i++){
  		if (filter_data.luoghi[i].slug !== '') {
  			luoghi_options += '<li class="pr-2 me-2" value=".luogo-'+filter_data.luoghi[i].slug+'">'+filter_data.luoghi[i].name+'</li>';
  		}
  	}
  	$('#luoghi-select li:not(:last)').remove();
  	$('#luoghi-select').prepend(luoghi_options);
    // se non ci sono termini non mostro il filtro
    if(filter_data.luoghi.length > 0){
      $('#filtri-luoghi').removeClass('d-none');
    } else {
      $('#filtri-luoghi').addClass('d-none');
    }

    /* ^ FINE update_filtri() ----------------------------------------- */
  };



  /* ---------------------------------------------------------
  FILTRO DEI CONTENUTI AL CLICK
  usato da: UbpHome.datiEdizione
  --------------------------------------------------------- */

  var filtraggioContenuti = function (projects_data) {

    // filtro promotori
    $('#promotori-select').on('click', 'li', function(e){
      $('#promotori-select li').removeClass('selected');
      $(this).toggleClass('selected');

      $container = $('#iso');
      var promotoriSelector = $(this).attr('value');
      $container.isotope({ filter: promotoriSelector	});
      $('.iso-list').isotope({ filter: promotoriSelector });

      // -----------------------------------
      // mostra su mappa
      if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).text();
        var selector_filter = $(this).attr('value');

        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);

        if (selector_filter !== '' && selector_filter !== '*') {
          // search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts, function(e){
            return e.nome_promotore == selector_title;
          });
        }
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
        LayoutMappa.mappa(sel_projects_data, 'FiltriContenuto.filtraggioContenuti promotori 167');

      }
      return false;
    });

    // filtro luoghi
    $('#luoghi-select').on('click', 'li', function(e){
      $('#luoghi-select li').removeClass('selected');
      $(this).toggleClass('selected');

      $container = $('#iso');
      var luoghi_selector = $(this).attr('value');
      $container.isotope({ filter: luoghi_selector });
      $('.iso-list').isotope({ filter: luoghi_selector });

      // -----------------------------------
      // mostra su mappa
      if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).text();
        var selector_filter = $(this).attr('value');

        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);

        //console.log('selector_filter:',selector_filter);
        if (selector_filter !== '' && selector_filter !== '*') {
          // search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts , function(obj) {
            var part = obj.locations;
            var inArray = false;
            for(var i=0;i<part.length;i++){
              if(part[i].city == selector_title){
                  return part[i].city;
              }
            }
          });
        }
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
        LayoutMappa.mappa(sel_projects_data, 'FiltriContenuto.filtraggioContenuti luoghi 207');
      }
      return false;
    });

    // filtro temi
    $('#filters-temi').on('click', 'li', function(e){
      e.preventDefault();
      $container = $('#iso');
      var $this = $(this);
      // don't proceed if already selected
      if ( $this.hasClass('selected') ) {
        return false;
      }
      var $optionSet = $this.parents('.option-set');
      $('#filters-temi').find('.selected').removeClass('selected');
      $this.addClass('selected');

      //When an item is clicked, sort the items.
      var selector = $(this).attr('data-filter');
      $container.isotope({ filter: selector });
      $('.iso-list').isotope({ filter: selector });

      if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).attr('data-title');
        var selector_filter = $(this).attr('data-filter');
        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);
        //console.log('selector_filter:',selector_filter);
        if (selector_filter !== '') {
          // search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts, function(e){
            if ($.inArray( selector_title, e.category_list ) != -1) {
                return e.category_list;
            }
          });
        }
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
        LayoutMappa.mappa(sel_projects_data, 'FiltriContenuto.filtraggioContenuti temi 246');
      }

      return false;

    });


    // filtro parolechiave
    $('#filters-parolechiave').on('click', 'li', function(e){
      e.preventDefault();
      $container = $('#iso');
      var $this = $(this);
      // don't proceed if already selected
      if ( $this.hasClass('selected') ) {
        return false;
      }
      var $optionSet = $this.parents('.option-set');
      $('#filters-parolechiave').find('.selected').removeClass('selected');
      $this.addClass('selected');

      //When an item is clicked, sort the items.
      var selector = $(this).attr('data-filter');
      $container.isotope({ filter: selector });
      $('.iso-list').isotope({ filter: selector });

      if ($('#projects-map').hasClass('active')) {
        var selector_title = $(this).attr('data-title');
        var selector_filter = $(this).attr('data-filter');
        // clone projects_data object
        var sel_projects_data = jQuery.extend({}, projects_data);
        //console.log('selector_filter:',selector_filter);
        if (selector_filter !== '') {
          // search for selected item in new object's post array
          sel_projects_data.posts = $.grep(projects_data.posts, function(e){
            if ($.inArray( selector_title, e.parolechiave_list ) != -1) {
                return e.parolechiave_list;
            }
          });
        }
        var project_count = sel_projects_data.posts.length;
        sel_projects_data.count = project_count;
        LayoutMappa.mappa(sel_projects_data, 'FiltriContenuto.filtraggioContenuti parole_chiave 288');
      }

      return false;

    });


    // togli
    // global search submit
    $('form#ubp-globalsearch-form .submit').on('click',function(e){
      e.preventDefault();
      $('form#ubp-globalsearch-form').submit();
    });


    /* ^ FINE filtroContenuti() ----------------------------------------- */
  };





  var start = function () {
    // Inizializzo il filtraggio dei contenuti
    // che verrà poi richiamato anche via ajax al caricamento della mappa
    // nella funzione UbpHome.datiEdizione
    // filtraggioContenuti();

    toggleSuperTile();
    // cambioEdizione();

    /* ^ FINE start() ----------------------------------------- */
  };


  return {
    start : start,
    update_filtri : update_filtri,
    filtraggioContenuti : filtraggioContenuti
  }


})();
